import { createFeedbackSummaryStore } from './createFeedbackSummaryStore';
import { FeedbackSummaryStoreContext } from './FeedbackSummaryStoreContext';

interface FeedbackSummaryStoreProviderProps {
  children: React.ReactNode;
}

export const FeedbackSummaryStoreProvider = ({
  children,
}: FeedbackSummaryStoreProviderProps) => {
  return (
    <FeedbackSummaryStoreContext.Provider
      createStore={createFeedbackSummaryStore}
    >
      {children}
    </FeedbackSummaryStoreContext.Provider>
  );
};
